"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Number = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Number = exports.Number = (_temp = _class = function (_React$Component) {
	_inherits(Number, _React$Component);

	function Number(props) {
		_classCallCheck(this, Number);

		return _possibleConstructorReturn(this, (Number.__proto__ || Object.getPrototypeOf(Number)).call(this, props));
	}

	_createClass(Number, [{
		key: "formatToString",
		value: function formatToString(val) {
			var val_string = this.placeSeparator(val);
			if (this.props.showSign) {
				if (val > 0) {
					val_string = '+' + val_string;
				}
			}
			return val_string;
		}
	}, {
		key: "placeSeparator",
		value: function placeSeparator(val) {
			var string_val = val.toString();
			if (this.props.decimals == 0) {
				string_val = string_val.replace('.', '');
				string_val = string_val.replace(',', '');
				return string_val;
			}
			if (string_val.length > this.props.decimals) {
				var separator_position = string_val.length - this.props.decimals;
				string_val = string_val.slice(0, separator_position) + this.props.decimalSeparator + string_val.slice(separator_position);
				if (string_val.indexOf('-,') != -1 || string_val.indexOf('-.') != -1) {
					string_val = string_val.replace('-.', '-0.');
					string_val = string_val.replace('-,', '-0,');
				}
				return string_val;
			} else if (string_val.length <= this.props.decimals) {
				var zeros = '';
				for (var i = string_val.length; i < this.props.decimals; i++) {
					zeros = zeros + '0';
				}
				var ret = '0' + this.props.decimalSeparator + zeros + val;
				return ret;
			}
			;
		}
	}, {
		key: "render",
		value: function render() {
			var decimals = this.props.decimals;
			var value = this.props.value * Math.pow(10, decimals);

			if (this.props.round == "UP") {
				value = Math.ceil(value);
			} else if (this.props.round == "DOWN") {
				value = Math.floor(value);
			} else if (this.props.round == "HALF_UP") {
				value = Math.round(value);
			}

			// wert == 0
			if (value == 0) {
				if (this.props.decimals == 0) {
					return 0;
				}
				var zeros = "0".repeat(decimals);
				return "0," + zeros;
			}

			var ret = this.formatToString(value);
			// console.log("ret: ", ret);
			return ret;
			// let string_value = value.toString();
			// let separator_position = string_value.length - decimals;
			//
			// string_value = string_value.slice(0, separator_position) + "," + string_value.slice(separator_position);
			//
			// let temp = string_value.replace("-", "");
			// if (temp[0] == ",") {
			// 	console.log(string_value.slice(0, string_value.indexOf(",")))
			// 	console.log("0" + string_value.slice(string_value.indexOf(",")))
			//
			// 	string_value = string_value.slice(0, string_value.indexOf(",")) + "0" + string_value.slice(string_value.indexOf(","));
			// }
			//
			// return string_value;
		}
	}]);

	return Number;
}(_react2.default.Component), _class.defaultProps = {
	decimals: 2,
	value: 0,
	round: "HALF_UP",
	decimalSeparator: ",",
	showSign: false
}, _class.propTypes = {
	decimals: _propTypes2.default.number,
	value: _propTypes2.default.number,
	round: _propTypes2.default.string
}, _temp);